import { render } from "./DepositPaymentMethod.vue?vue&type=template&id=15d43f48"
import script from "./DepositPaymentMethod.vue?vue&type=script&lang=js"
export * from "./DepositPaymentMethod.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__